import type { FaireProductEntity } from "../../entity_types/product";

export const p_rktvfj3gdj: FaireProductEntity = {
  token: "p_rktvfj3gdj",
  type: "product",
  name: "Tuberose Musk– HI-FI Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/298480b2b66c395a4dd59dfac76e678610d21bf649ae965e92ff9d4f9b7610db.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c322317d3cf3a12a055782d13dd19f943517e18be5cbf1057d5b006ed1143363.jpeg",
    "https://cdn.faire.com/fastly/171bfc2dbfc8ad7d6ba49d11392e70c28a242643a521f7fdd0b22561c54fbba4.jpeg",
    "https://cdn.faire.com/fastly/1800cee1b16136e06841986db86e83ff461a99b2a2da537025a479230571633c.jpeg",
    "https://cdn.faire.com/fastly/56581e0a3cff8ab7cdb8fa29065a6d7cb0e7a7f1e17d2bea7f273c75ba54023a.jpeg",
  ],
  priceDollars: 19.5,
  description:
    '*Due to unexpected supply chain shifts, we are experiencing a gap in our production schedule. Sold out HI-FI products are expected to restock this Summer*\n\nAn opulent green floral. Escapes to warmer climates, gardens draped in morning dew, light streaming through sheer curtains.\n\nTuberose Musk is an opulent green floral, for post-clean resets, instant grounding, and escapes to warmer climates. This scent feels both familiar and dreamy, evocative of ornate vases bursting with white florals, gardens draped in morning dew, and light streaming through sheer curtains.\n\nTop notes of fresh cut stems, orange blossom, and ozone are blended with blooming tuberose, jasmine sambac, and ylang ylang, balanced by cashmere wood, sheer sandalwood, and translucent musk for lovers of Sandalwood Rose and Saltwater Jasmine.\n\nPRODUCT INFORMATION:\n\nEach diffuser contains a 4 fl oz blend of naturally-derived and man-made fragrance oils in a square custom cocoa brown glass bottle with a Vermilion debossed front label and packaged in a premium paper gift box.\n\nLasts approximately 3-4 months.\n\nIncludes a bundle of 9" long naturally-harvested black dyed rattan reeds to absorb and slowly release the fragrance.',
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:57.735Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
